<div class="auth-page-wrapper pt-5">
  <div class="auth-one-bg-position auth-one-bg" id="auth-particles">
    <div class="bg-overlay"></div>
    <div class="shape">
      <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 1440 120">
        <path d="M 0,36 C 144,53.6 432,123.2 720,124 C 1008,124.8 1296,56.8 1440,40L1440 140L0 140z"></path>
      </svg>
    </div>
  </div>
  <div class="auth-page-content overflow-hidden p-5">
		<div class="container-fluid">
			<div class="row justify-content-center">
				<div class="col-xl-4 text-center">
					<div class="error-500 position-relative">
						<img src="assets/images/errors/error500.png" alt="" class="img-fluid error-500-img error-img pt-4" />
						<h1 class="title text-muted">401</h1>
					</div>
					<div>
						<h4>Unauthorized 401!</h4>
						<p class="text-muted w-75 mx-auto">Your token is expired or not authorized to access this assessment.</p>
					</div>
				</div>
			</div>
		</div>
	</div>
  <footer class="footer">
		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-6">
					{{year}} © Revealense. Illuminate the hidden
				</div>
				<div class="col-sm-6">
					<div class="text-sm-end d-none d-sm-block">
						<a href="https://lordicon.com/">Animated icons by Lordicon.com</a>
					</div>
				</div>
			</div>
		</div>
	</footer>
</div>